import React from 'react';
import { useCurrency } from '../../lib/currency-context';

/** Airtuerk fiyatı (EUR kaynak) — seçili para biriminde gösterim. */
export default function FlightPrice({
  amountEur,
  size = 'default',
  className = '',
  loading = false,
  valueClassName = '',
}) {
  const { formatPrice } = useCurrency();
  const eur = Number(amountEur) || 0;

  const sizeClasses = {
    lg: 'text-3xl',
    default: 'text-2xl',
    sm: 'text-base',
    inline: 'text-sm font-semibold',
  };

  return (
    <div className={className}>
      <div className={`font-bold text-sky-600 ${sizeClasses[size] || sizeClasses.default} ${valueClassName}`}>
        {loading ? '…' : formatPrice(eur, 'EUR')}
      </div>
    </div>
  );
}

/** Satır içi fiyat (tablo, özet satırları) */
export function FlightPriceInline({ amountEur, loading = false, className = '' }) {
  const { formatPrice } = useCurrency();
  if (loading) return <span className={className}>…</span>;
  return (
    <span className={className}>
      {formatPrice(Number(amountEur) || 0, 'EUR')}
    </span>
  );
}
